import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMenuItem } from 'src/app/classes/interfaces/menu-item';
import { Router } from '@angular/router';
import { UserItems, UserLogin } from 'src/app/classes/interfaces/useritems.interface';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-header-lg',
  templateUrl: './header-lg.component.html',
  styleUrls: ['./header-lg.component.scss'],
})

export class HeaderLgComponent {
  
  isHover = false;
  activeRoute: string = '';
  open = false;

  private _searchInput: Subject<string> = new Subject<string>();
  private _searchInputSubscription!: Subscription;
  
  @Output('logOut') logOut = new EventEmitter<void>();
  @Output('modal') openingModal: EventEmitter<string> = new EventEmitter(false);
  @Input('userLogin') userLogin : Array<UserLogin>;
  @Input('menuItems') menuItems : Array<IMenuItem>;
  @Input('isLogin') isLogin : boolean;
  @Input('userItems') userItems : Array<UserItems>;
  
  showDropdown: string | null = null;

  constructor(private router: Router, private toaster: ToastrService) {}

  ngOnInit() {
    this.activeRoute = this.router.url.split('/')[1];
        // تنظیم debounce روی input
    this._searchInputSubscription = this._searchInput
      .pipe(debounceTime(800))
      .subscribe(value => {
        if (value.length >= 3) {
          this.searchFilterName(value);
        } else {
          this.toaster.error('حداقل باید ۳ کاراکتر برای جستجو وارد شود');
        }
      });
  }

  openModal(type: string) {
    this.openingModal.emit(type);
  }
  
  logOutUser(index : number){
    if (index == 0){
      this.logOut.emit();
    }
  }
 
 // دریافت مقادیر input
  fillValue(value: string) {
    this._searchInput.next(value);
  }

  // ریدایرکت به صفحه search
  searchFilterName(value: string) {
    this.router.navigateByUrl(`search?search=${value}`);
  }

  // باز و بسته کردن dropdown
  toggle() {
    this.open = !this.open;
    if (this.open) {
      setTimeout(() => {
        const input = document.querySelector('.search-input') as HTMLInputElement;
        input?.focus();
      }, 50);
    }
  }
  inHover(){
    this.isHover = true;
  }
  onHover(){
    this.isHover = false;
  }
}
